<template>
  <div>
    <div class="for-mobile">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2>CONTACT US</h2>
            <div class="title bold-700">{{ $t("contact.text1") }}</div>
            <div class="email">
              <a href="mailto:contact@burninggalaxy.com"
                >contact@burninggalaxy.com</a
              >
            </div>
            <div class="address">
              {{ $t("contact.text2") }}
              <div>
                Daechi Building 10F, 408, Teheran-ro, Gangnam-gu, Seoul
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="google-map" v-if="locale === 'ko'">
        <iframe
          :src="GOOGLE_MAP_EMBED_URL_KOREA"
          width="100%"
          height="450"
          style="border: 0"
          allowfullscreen=""
          loading="lazy"
        ></iframe>
      </div>
      <div class="google-map" v-if="locale === 'en'">
        <iframe
          :src="GOOGLE_MAP_EMBED_URL_US"
          width="100%"
          height="450"
          style="border: 0"
          allowfullscreen=""
          loading="lazy"
        ></iframe>
      </div>
      <div class="google-map" v-if="locale === 'cn'">
        <img src="/images/cn-map-m.png" alt="" width="100%" />
      </div>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="title bold-700">BURNING GALAXY CHINA</div>
            <div class="address">
              Room 1903, 398 Guiyang Rd Shanghai, China, 200090
            </div>
            <div class="title bold-700">BURNING GALAXY US</div>
            <div class="address">
              660 South Figueroa Street, SUITE 1960, Los Angeles, CA 90017
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="for-pc">
      <div class="container">
        <div class="row wrap">
          <div class="col-4 center">
            <h2>CONTACT US</h2>
            <div class="title bold-700">{{ $t("contact.text1") }}</div>
            <div class="email">
              <a href="mailto:contact@burninggalaxy.com"
                >contact@burninggalaxy.com</a
              >
            </div>
            <div class="address mb">
              {{ $t("contact.text2") }}
              <div>
                Daechi Building 10F, 408, Teheran-ro, Gangnam-gu, Seoul
              </div>
            </div>
            <div>
              <div class="title bold-700">BURNING GALAXY CHINA</div>
              <div class="address mb">
                Room 1903, 398 Guiyang Rd Shanghai, China, 200090
              </div>
              <div class="title bold-700">BURNING GALAXY US</div>
              <div class="address">
                660 South Figueroa Street, SUITE 1960, Los Angeles, CA 90017
              </div>
            </div>
          </div>
          <div class="col-8 center">
            <div class="google-map" v-if="locale === 'ko'">
              <iframe
                :src="GOOGLE_MAP_EMBED_URL_KOREA"
                width="100%"
                height="450"
                style="border: 0"
                allowfullscreen=""
                loading="lazy"
              ></iframe>
            </div>
            <div class="google-map" v-if="locale === 'en'">
              <iframe
                :src="GOOGLE_MAP_EMBED_URL_US"
                width="100%"
                height="450"
                style="border: 0"
                allowfullscreen=""
                loading="lazy"
              ></iframe>
            </div>
            <div class="google-map" v-if="locale === 'cn'">
              <img src="/images/cn-map.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GOOGLE_MAP_EMBED_URL_KOREA, GOOGLE_MAP_EMBED_URL_US } from "../const";

export default {
  name: "Contact",
  created() {
    this.GOOGLE_MAP_EMBED_URL_KOREA = GOOGLE_MAP_EMBED_URL_KOREA;
    this.GOOGLE_MAP_EMBED_URL_US = GOOGLE_MAP_EMBED_URL_US;
    this.locale = this.$root.$i18n.locale;
  },
  data: function () {
    return {
      GOOGLE_MAP_EMBED_URL_KOREA,
      GOOGLE_MAP_EMBED_URL_US,
      locale: this.$root.$i18n.locale,
    };
  },
  watch: {
    "$i18n.locale": function (newVal) {
      this.locale = newVal;
    },
  },
};
</script>
